import React, { ChangeEvent, useEffect, useState } from 'react';
import { ModalWithButtons } from '../ModalWithButtons/ModalWithButtons.component';
import { Grid, InputLabel, TextField } from '@material-ui/core';
import { updateUserName } from '../../services/users/users.service';
import { IUserProfile } from './IUserProfile.types';
import { useLayoutContext } from '../../Context/Layout.context';
import { useStyles, } from './EditUserName.styles';
import { authActions } from '../../reducers/authReducer/authSlice';
import userManager from '../../services/users/identity/user.service';
import { useDispatch } from 'react-redux';

interface EditUserNameProps {
  user: IUserProfile | undefined;
  open: boolean;
  onClose: () => void;
  onNavBack: () => void;
}

export const EditUserName: React.FC<EditUserNameProps> = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [firstName, setFirstName] = useState<string | undefined>(undefined);
  const [lastName, setLastName] = useState<string | undefined>(undefined);

  const { openAlert, setIsLoader } = useLayoutContext();

  useEffect(() => {
    if (props.user) {
      setFirstName(props.user.name);
      setLastName(props.user.surname);
    }
  }, [props.user]);

  const clearInputs = () => {
    if (props.user) {
      setFirstName(props.user.name);
      setLastName(props.user.surname);
    }
  };

  const updateLoggedUser = async (firstName: string, lastName: string) => {
    const userFromUserManager = await userManager.getUser();
    if (userFromUserManager && userFromUserManager.profile) {
      userFromUserManager.profile.given_name = firstName;
      userFromUserManager.profile.family_name = lastName;
      userFromUserManager.profile.name = `${firstName} ${lastName}`;
      dispatch(authActions.storeUserAndSetAuthHeader(userFromUserManager));
      userManager.storeUser(userFromUserManager);
    }
  };

  const handleUpdateUserName = (firstName: string, lastName: string) => {
    setIsLoader(true);
    updateUserName(firstName, lastName).then(
      () => {
        updateLoggedUser(firstName, lastName);
        setIsLoader(false);
        openAlert('success');
        clearInputs();
        props.onClose();
        props.onNavBack();
      },
      () => {
        setIsLoader(false);
        openAlert('save_error');
      },
    );
  };

  const isUserDataUpdated = (): boolean => {
    return (
      !!props.user &&
      props.user.name !== '' &&
      props.user.surname !== '' &&
      firstName !== '' &&
      lastName !== '' &&
      (firstName !== props.user.name || lastName !== props.user.surname)
    );
  };

  const handleUpdateUserData = () => {
    if (isUserDataUpdated()) {
      if (firstName && lastName) {
        setFirstName(firstName);
        setLastName(lastName);
        handleUpdateUserName(firstName, lastName);
      }
    }
  };

  const onCancelEdit = () => {
    clearInputs();
    props.onClose();
    props.onNavBack();
  };

  return (
    <>
      {props.user && (
        <ModalWithButtons
          open={props.open}
          size="sm"
          navButtonLabel={'Mój profil'}
          handleNavBack={onCancelEdit}
          xCloseButton={onCancelEdit}
          autoHeight={true}
          onCancel={onCancelEdit}
          onConfirm={handleUpdateUserData}
          confirmButtonLabel="Aktualizuj"
          confirmButtonDisabled={!isUserDataUpdated()}
          buttonsContainerStyle={{ marginTop: '60px' }}
        >
          <Grid container className={classes.container}>
            <Grid>
              <div className={classes.modalSubTitle}>Edytuj imię i nazwisko</div>
            </Grid>
            <Grid item xs={6} className={classes.item}>
              <TextField
                value={firstName}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value.trim())}
                id="first-name"
                label="Imię"
                placeholder="Imię"
                variant="outlined"
                inputProps={{
                  style: {
                    width: '345px',
                    padding: '15.5px',
                    color: '#2C2D3E',
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={6} className={classes.item}>
              <TextField
                value={lastName}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setLastName(e.target.value.trim())}
                id="last-name"
                label="Nazwisko"
                placeholder="Nazwisko"
                variant="outlined"
                inputProps={{
                  style: {
                    width: '345px',
                    padding: '15.5px',
                    color: '#2C2D3E',
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </ModalWithButtons>
      )}
    </>
  );
};
